import Vue from 'vue'
import {Button,Table,Form,Input,FormItem,Message,LoadingBar,Menu,MenuItem,MenuGroup,Modal,
	Icon,Submenu,Notice,Select,Option,BackTop,Tree,Row,Col,DatePicker,TimePicker,RadioGroup,Radio,
	CheckboxGroup,Checkbox,Tabs,TabPane,Dropdown,DropdownMenu,DropdownItem,Badge,Avatar,Poptip,Card,
	Breadcrumb,BreadcrumbItem,Page,Tooltip,CarouselItem,Carousel,Spin,Switch,Slider,Progress,InputNumber,Tag,Drawer} from 'iview';

const iview = {
    install: function (Vue) {
		Vue.component('Button', Button);
		Vue.component('Table', Table);
		Vue.component('Form', Form);
		Vue.component('FormItem', FormItem);
		Vue.component('Input', Input);
		Vue.component('Select', Select);
		Vue.component('Option', Option);
		Vue.component('Row', Row);
		Vue.component('Col', Col);
		Vue.component('DatePicker', DatePicker);
		Vue.component('TimePicker', TimePicker);
		Vue.component('RadioGroup', RadioGroup);
		Vue.component('Radio', Radio);
		Vue.component('CheckboxGroup', CheckboxGroup);
		Vue.component('Checkbox', Checkbox);
		Vue.component('Message', Message);
		Vue.component('LoadingBar', LoadingBar);
		Vue.component('Menu', Menu);
		Vue.component('MenuItem', MenuItem);
		Vue.component('MenuGroup', MenuGroup);
		Vue.component('Icon', Icon);
		Vue.component('Submenu', Submenu);
		Vue.component('Notice', Notice);
		Vue.component('InputNumber', InputNumber);
		Vue.component('BackTop', BackTop);
		Vue.component('Tree', Tree);
		Vue.component('Modal', Modal);
		Vue.component('Tabs', Tabs);
		Vue.component('TabPane', TabPane);
		Vue.component('Dropdown', Dropdown);
		Vue.component('DropdownMenu', DropdownMenu);
		Vue.component('DropdownItem', DropdownItem);
		Vue.component('Badge', Badge);
		Vue.component('Avatar', Avatar);
		Vue.component('Poptip', Poptip);
		Vue.component('Card', Card);
		Vue.component('Breadcrumb', Breadcrumb);
		Vue.component('BreadcrumbItem', BreadcrumbItem);
		Vue.component('Page', Page);
		Vue.component('Tooltip', Tooltip);
		Vue.component('Carousel', Carousel);
		Vue.component('CarouselItem', CarouselItem);
		Vue.component('Spin', Spin);
		Vue.component('i-switch',Switch);
		Vue.component('Slider',Slider);
		Vue.component('Progress',Progress);
		Vue.component('Tag',Tag);
		Vue.component('Drawer',Drawer);

    }
}

export default iview

Vue.prototype.$Message = Message
Vue.prototype.$Loading = LoadingBar
Vue.prototype.$Notice = Notice
Vue.prototype.$Modal = Modal
